// Phase 3 — Multi-channel additions on top of the Phase 2 file.
import { request, API } from './api';

function mediaHref(r2_key) {
    const path = r2_key.split('/').map(encodeURIComponent).join('/');
    return `${API}/messagerie/media/${path}`;
}

async function uploadMedia({ conversationId, kind, file, onProgress }) {
    const url = `${API}/messagerie/upload-media`;
    const form = new FormData();
    form.append('conversation_id', conversationId);
    form.append('kind', kind);
    form.append('file', file, file.name);
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.withCredentials = true;
        if (xhr.upload && onProgress) {
            xhr.upload.onprogress = (e) => {
                if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
            };
        }
        xhr.onerror = () => reject(new Error('Erreur réseau pendant l\u2019envoi'));
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                try { resolve(JSON.parse(xhr.responseText)); } catch { resolve({}); }
            } else {
                let detail = `HTTP ${xhr.status}`;
                try { detail = JSON.parse(xhr.responseText).detail || detail; } catch { /* ignore */ }
                reject(Object.assign(new Error(detail), { detail, status: xhr.status }));
            }
        };
        xhr.send(form);
    });
}

export const messagerieApi = {
    listConversations: (params) => request('/messagerie/conversations', { params }),
    getConversation: (id) => request(`/messagerie/conversations/${id}`),
    getMessages: (id, params) => request(`/messagerie/conversations/${id}/messages`, { params }),
    send: (body, opts = {}) => request('/messagerie/send', { method: 'POST', body, ...opts }),
    markRead: (id, opts = {}) => request(`/messagerie/conversations/${id}/mark-read`, { method: 'POST', body: {}, ...opts }),
    reassign: (id, agent_user_id) => request(`/messagerie/conversations/${id}/reassign`, { method: 'POST', body: { agent_user_id } }),
    // Phase A.1 — on-demand resolution of `contact_name` via Whapi. Silencieux
    // par défaut : en preview (tokens vides) le backend renvoie `refreshed:false`
    // sans erreur ; côté UI on reste sur le fallback numéro.
    refreshContactName: (id, opts = { silent: true }) =>
        request(`/messagerie/conversations/${id}/refresh-contact-name`, { method: 'POST', body: {}, ...opts }),
    // Phase B.3 — Réactions emoji. body: {emoji: "👍"} ou {emoji: ""} pour retirer.
    react: (message_id, emoji) =>
        request(`/messagerie/messages/${message_id}/react`, { method: 'POST', body: { emoji } }),
    seedDemo: () => request('/messagerie/_seed_demo', { method: 'POST', body: {} }),
    bridgeStatus: () => request('/messagerie/bridge-status', { silent: true }),
    // Phase 4 — groupes WhatsApp
    getGroup: (group_id) => request(`/messagerie/groups/${encodeURIComponent(group_id)}`),
    uploadMedia,
    mediaHref,
};

// Phase 3 — Whapi channels admin API.
export const channelsApi = {
    list: () => request('/whatsapp-channels'),
    patch: (channel_id, body) => request(`/whatsapp-channels/${channel_id}`, { method: 'PATCH', body }),
    // Phase 5 — pairing QR réel (mocké en preview).
    startPairing: (channel_id) => request(`/whatsapp-channels/${channel_id}/start-pairing`, { method: 'POST', body: {} }),
    pairingStatus: (channel_id) => request(`/whatsapp-channels/${channel_id}/pairing-status`, { silent: true }),
};

// Phase 5 — Journal d'audit + événements santé canaux.
export const auditApi = {
    list: (params) => request('/audit-log', { params }),
};
export const healthApi = {
    events: (params) => request('/channel-health-events', { params }),
};
